export default "__VITE_ASSET__d651a4ad__"